import { cn } from '@/lib/utils';

export interface SegmentOption<T extends string = string> {
  id: T;
  label: string;
  icon?: React.ComponentType<{ className?: string }>;
}

interface SegmentedControlProps<T extends string = string> {
  options: SegmentOption<T>[];
  value: T;
  onChange: (id: T) => void;
  className?: string;
}

export function SegmentedControl<T extends string = string>({
  options,
  value,
  onChange,
  className,
}: SegmentedControlProps<T>) {
  return (
    <div className={cn('inline-flex rounded-lg bg-surface p-1 text-xs dark:bg-card', className)}>
      {options.map(opt => {
        const Icon = opt.icon;
        return (
          <button
            key={opt.id}
            type="button"
            onClick={() => onChange(opt.id)}
            className={cn(
              'flex items-center gap-1 rounded-md px-3 py-1.5 font-medium transition',
              value === opt.id
                ? 'bg-white text-ink-900 shadow-sm dark:bg-secondary dark:text-white'
                : 'text-ink-500 dark:text-muted-foreground',
            )}
          >
            {Icon && <Icon className="h-3 w-3" />}
            {opt.label}
          </button>
        );
      })}
    </div>
  );
}
